import { render, staticRenderFns } from "./PgmMng.vue?vue&type=template&id=58787055"
import script from "./PgmMng.vue?vue&type=script&lang=js"
export * from "./PgmMng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports